export const OFFLINE_PROJECT_CHANGED_EVENT = 'doddledays:offline-project-changed';

export function notifyOfflineProjectChanged(projectSlug: string): void {
  if (typeof window === 'undefined' || !projectSlug) return;
  window.dispatchEvent(new CustomEvent(OFFLINE_PROJECT_CHANGED_EVENT, { detail: { projectSlug } }));
}

export function offlineProjectSlugFromEvent(event: Event): string | null {
  if (!(event instanceof CustomEvent)) return null;
  const value = event.detail?.projectSlug;
  return typeof value === 'string' && value.length > 0 ? value : null;
}
